import { render, staticRenderFns } from "./CurriculumStudentViewRead.vue?vue&type=template&id=07b3a50d&scoped=true&"
import script from "./CurriculumStudentViewRead.vue?vue&type=script&lang=ts&"
export * from "./CurriculumStudentViewRead.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumStudentViewRead.vue?vue&type=style&index=0&id=07b3a50d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b3a50d",
  null
  
)

export default component.exports